import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Col, Empty, Row, Skeleton, notification } from "antd";
import { useEffect, useState } from "react";
import "./searcher.scss";
import { capitalizeString } from "../../../shared/util";
import Moment from "react-moment";
import { Contact, DataItem, PageSetting, routerData } from "../..";
import store from "../../../controllers/store";
import { findById } from "../../../controllers/store/actions/searchers/get-searcher-actions";
import { useSelector } from "react-redux";
import RecomendationList from "../../components/Recomedations";
import useRecomendations from "../../../hooks/recomendations-entities-hook";

const dispatch = store.dispatch;
const SearcherDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const SearcherState = useSelector((state: any) => state.searcher);
  const { result, getRecomendations } = useRecomendations();
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contact, setContact] = useState<Contact>();
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const go = (params: routerData, entity: any) => {
    navigate(`/${entity}/${params.id}`, { state: { params, entity } });
  };

  useEffect(() => {
    if (id) {
      dispatch(findById(id));
    }

    getRecomendations("all", { filter: "" }, 1, 5);
  }, []);
  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <Skeleton loading={SearcherState.isLoading} active className="full-width">
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={8} lg={16}>
            <h1 className="conection-heading-section">Datos generales</h1>
            <Card
              className="ant-card-conection ant-card-conection-border"
              onClick={() => {}}
              hoverable
              style={{ width: "100%", marginBottom: 30 }}
            >
              <Row gutter={[8, 8]} style={{ width: "100%" }}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <h2 className="conection-label">Nombre</h2>
                  <p className="conection-value">
                    {(
                      SearcherState?.searcher?.nombre || "sin definir"
                    ).toUpperCase()}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <h2 className="conection-label">Filiación institucional</h2>
                  <p className="conection-value">
                    {capitalizeString(
                      SearcherState?.searcher?.inst_filia || "sin definir"
                    )}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <h2 className="conection-label">Nivel de formación</h2>
                  <p className="conection-value">
                    {SearcherState?.searcher?.nme_niv_form_pr}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <h2 className="conection-label">Clasificación</h2>
                  <p className="conection-value">
                    {SearcherState?.searcher?.nme_clasificacion_pr}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <h2 className="conection-label">Gran área de conocimiento</h2>
                  <p className="conection-value">
                    {
                      SearcherState?.searcher?.nme_gran_area_pr
                        ?.GRAN_AREA_DE_CONOCIMIENTO
                    }
                  </p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <h2 className="conection-label">Área de conocimiento</h2>
                  <p className="conection-value">
                    {SearcherState?.searcher?.nme_area_pr?.AREA_DE_CONOCIMIENTO}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <h2 className="conection-label">
                    Especialidad del conocimiento
                  </h2>
                  <p className="conection-value">
                    {
                      SearcherState?.searcher?.nme_esp_area_pr
                        ?.ESPECIALIDAD_DE_CONOCIMIENTO
                    }
                  </p>
                </Col>
                {SearcherState?.searcher?.features ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Características</h2>
                    <p className="conection-value">
                      {SearcherState?.searcher?.features || "sin definir"}
                    </p>
                  </Col>
                ) : null}

                {SearcherState?.searcher?.issue_date ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Fecha de expedición</h2>
                    <p className="conection-value">
                      {SearcherState?.searcher?.issue_date || "N/A"}
                    </p>
                  </Col>
                ) : null}
                {SearcherState?.searcher?.current_date ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Vigencia</h2>
                    <p className="conection-value">
                      {SearcherState?.searcher?.current_date || "N/A"}
                    </p>
                  </Col>
                ) : null}
                {SearcherState?.searcher?.update_date ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Última Actualización</h2>
                    <p className="conection-value">
                      {SearcherState?.searcher?.update_date || "N/A"}
                    </p>
                  </Col>
                ) : null}
                {SearcherState?.searcher?.source ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Fuente</h2>
                    <p className="conection-value">
                      {SearcherState?.searcher?.source}
                    </p>
                  </Col>
                ) : null}
                {SearcherState?.searcher?.recognized_min ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">
                      Reconociento Minciencias (Sí/No){" "}
                    </h2>
                    <p className="conection-value">
                      {SearcherState?.searcher?.recognized_min === 1
                        ? "Si"
                        : "No"}
                    </p>
                  </Col>
                ) : null}
              </Row>
              <Row>
                {SearcherState?.searcher?.enlace_cvlac ? (
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <h2 className="conection-label">URL</h2>
                    {SearcherState?.searcher?.enlace_cvlac ? (
                      <Button
                        type="primary"
                        onClick={() => {
                          window.open(
                            SearcherState?.searcher?.enlace_cvlac,
                            "_blank"
                          );
                        }}
                      >
                        Abrir CVLAC
                      </Button>
                    ) : (
                      "Sin url"
                    )}
                  </Col>
                ) : null}
              </Row>
            </Card>
            {SearcherState?.searcher?.groups?.length > 0 ? (
              <>
                <h1 className="conection-heading-section">Grupos</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} className="full-width">
                    <Col xs={24} sm={12} md={8} lg={24}>
                      {!SearcherState?.searcher?.groups ||
                      SearcherState?.searcher?.groups?.length === 0 ? (
                        <Empty description={"0 Registros"} />
                      ) : null}
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {SearcherState?.searcher.groups?.map((g: any) => {
                      return (
                        <Col xs={24} sm={12} md={8} lg={12}>
                          <Button
                            className="connection-font"
                            size="middle"
                            onClick={() => {
                              go(
                                {
                                  id: g.groups_id.id,
                                  name: g.groups_id.nme_grupo_gr,
                                  type: g.groups_id.actor_type.actor,
                                },
                                "groups"
                              );
                            }}
                            style={{
                              marginBottom: 10,
                              marginRight: 20,
                              width: "auto",
                            }}
                          >
                            {capitalizeString(g.groups_id.nme_grupo_gr)}
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                </Card>
              </>
            ) : null}
            {SearcherState?.searcher?.universities?.length > 0 ? (
              <>
                <h1 className="conection-heading-section">Instituciones</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {SearcherState?.searcher?.universities.map((g: any) => {
                      return (
                        <Col xs={24} sm={12} md={8} lg={12}>
                          <Button
                            className="connection-font"
                            size="middle"
                            onClick={() => {
                              console.log("args", {
                                id: g.universities_id.id,
                                name: g.universities_id.institution_name,
                                type: g.universities_id.actor_type.actor,
                              });
                              go(
                                {
                                  id: g.universities_id.id,
                                  name: g.universities_id.institution_name,
                                  type: g.universities_id.actor_type.actor,
                                },
                                "universities"
                              );
                            }}
                            style={{
                              marginBottom: 10,
                              marginRight: 20,
                              width: 450,
                            }}
                          >
                            {capitalizeString(
                              g.universities_id?.institution_name || ""
                            )}
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                </Card>
              </>
            ) : null}
            {SearcherState?.searcher?.products?.length > 0 ? (
              <>
                <h1 className="conection-heading-section">Productos</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {SearcherState?.searcher?.products?.map((g: any) => {
                      return (
                        <Col xs={24} sm={12} md={8} lg={12}>
                          <Button
                            className="connection-font"
                            size="middle"
                            title={g.products_id.nme_producto_pd || ""}
                            style={{
                              overflow: "hidden",
                              whiteSpace: "normal",
                              textOverflow: "ellipsis",
                            }}
                            onClick={() => {
                              go(
                                {
                                  id: g.products_id.id,
                                  name: g.products_id.nme_producto_pd,
                                  type: g.products_id.capacity_type.capacities,
                                },
                                "products"
                              );
                            }}
                          >
                            {capitalizeString(
                              g.products_id?.nme_producto_pd || ""
                            )}
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                </Card>
              </>
            ) : null}
            {SearcherState?.searcher?.entities?.length > 0 ? (
              <>
                <h1 className="conection-heading-section">Empresas</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {SearcherState?.searcher?.entities.map((g: any) => {
                      return (
                        <Col xs={24} sm={12} md={8} lg={12}>
                          <Button
                            className="connection-font"
                            size="middle"
                            onClick={() => {
                              go(
                                {
                                  id: g.entities_id.id,
                                  name: g.entities_id.social_reason,
                                  type: g.entities_id.actor_type.actor,
                                },
                                "entities"
                              );
                            }}
                            style={{
                              marginBottom: 10,
                              marginRight: 20,
                              width: 450,
                            }}
                          >
                            {capitalizeString(
                              g.entities_id?.social_reason || ""
                            )}
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                </Card>
              </>
            ) : null}
          </Col>
          {user?.me ? (
            <Col xs={24} sm={12} md={8} lg={8}>
              <h1 className="conection-heading-section">Sugerencias</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%" }}
              >
                <Skeleton
                  loading={result.loading}
                  active
                  className="full-width"
                >
                  <RecomendationList
                    totalPages={result.pagination?.total}
                    onPaginationChanged={(page) => {
                      getRecomendations(
                        "all",
                        { filter: {} },
                        page,
                        PageSetting.limit
                      );
                      setPage(page);
                    }}
                    onConnect={(contact) => {
                      setContact({
                        name: contact.title,
                        type: contact.description,
                        email: contact.contact_email,
                      });
                      setIsModalOpen(!isModalOpen);
                    }}
                    data={result.values
                      .filter((r) => r.id !== id)
                      .map((recomendation: any) => {
                        return {
                          title: recomendation.name,
                          description: `${recomendation.type.actor} - ${
                            recomendation.city || recomendation.cityRaw || ""
                          }`,
                          avatar: "",
                          contact_email: recomendation.contact_email,
                        } as DataItem;
                      })}
                  />
                </Skeleton>
              </Card>
            </Col>
          ) : null}
        </Row>
      </Skeleton>
    </div>
  );
};

export default SearcherDetail;
